import React from 'react';
import { Button } from 'antd';
import { Layout } from '../../common';
import ConfigHeader from './ConfigHeader';
import styles from './styles/configuration-success.module.scss';

function ConfigurationSuccess({ onContinue }) {
    return (
        <Layout>
            <div className={styles.successContainer}>
                <ConfigHeader isFirstTimeSetUp={true} currentStep={5} />

                <div className={styles.content}>
                    <img src="/flow-complete.png" alt="Configuration Complete" className={styles.successImage} />

                    <div className={styles.actionContainer}>
                        <Button type="primary" size="large" onClick={onContinue} className={styles.continueButton}>
                            Continue
                        </Button>
                    </div>
                </div>
            </div>
        </Layout>
    );
}

export default ConfigurationSuccess;
